import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d9dc8404"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container mt-4" }
const _hoisted_2 = { class: "row mt-3 mb-1 px-3" }
const _hoisted_3 = { class: "col" }
const _hoisted_4 = { class: "col text-end fa" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("i", {
    class: "fa fa-eye px-2",
    "aria-hidden": "true"
  })
], -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("i", {
    class: "fa fa-edit px-2",
    "aria-hidden": "true"
  })
], -1))
const _hoisted_7 = ["data-bs-target"]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("i", {
    class: "fa fa-trash px-2",
    "aria-hidden": "true"
  })
], -1))
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { style: {"width":"98%","margin":"6px auto"} }, null, -1))
const _hoisted_11 = { class: "row mt-4 mb-2 mx-1" }
const _hoisted_12 = { class: "col" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-calendar calender-green",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_14 = { class: "col text-end" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-calendar calender-red",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_16 = { class: "card-body pt-0" }
const _hoisted_17 = { class: "my-5" }
const _hoisted_18 = { class: "svg-icon svg-icon-1" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex-grow-1 me-2" }, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "#",
    class: "fw-bolder text-gray-800 text-hover-primary fs-6"
  }, "Funding Required")
], -1))
const _hoisted_20 = { class: "svg-icon svg-icon-1" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex-grow-1 me-2" }, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "#",
    class: "fw-bolder text-gray-800 text-hover-primary fs-6"
  }, "Pre-Money Valuation")
], -1))
const _hoisted_22 = { class: "svg-icon svg-icon-1" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex-grow-1 me-2" }, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "#",
    class: "fw-bolder text-gray-800 text-hover-primary fs-6"
  }, "Minimum Investment")
], -1))
const _hoisted_24 = { class: "svg-icon svg-icon-1" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex-grow-1 me-2" }, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "#",
    class: "fw-bolder text-gray-800 text-hover-primary fs-6"
  }, "Total Investment")
], -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row my-3" }, [
  /*#__PURE__*/_createElementVNode("h3", null, "Investment History")
], -1))
const _hoisted_27 = { class: "row mb-7" }
const _hoisted_28 = {
  key: 1,
  class: "d-flex justify-content-center"
}
const _hoisted_29 = { class: "row mt-4 mb-3 pr-3" }
const _hoisted_30 = { class: "col text-end mx-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_InvestmentHistory = _resolveComponent("InvestmentHistory")!
  const _component_DeleteFundingRoundModal = _resolveComponent("DeleteFundingRoundModal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rounds, (round) => {
      return (_openBlock(), _createElementBlock("section", {
        key: round.id,
        class: "border rounded-5"
      }, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("strong", null, [
              _createElementVNode("span", null, _toDisplayString(round.name), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_router_link, {
              class: "w-un",
              to: `/view-funding-round/${round.id}?businessId=${round.businessId}`
            }, {
              default: _withCtx(() => [
                _hoisted_5
              ]),
              _: 2
            }, 1032, ["to"]),
            _createVNode(_component_router_link, {
              class: "w-un",
              to: `/update-funding-round/${round.id}?businessId=${round.businessId}`
            }, {
              default: _withCtx(() => [
                _hoisted_6
              ]),
              _: 2
            }, 1032, ["to"]),
            _createElementVNode("a", {
              "data-bs-toggle": "modal",
              "data-bs-target": `#kt_modal_delete_round_${round.id}`,
              class: "w-un",
              href: "javascript:void(0)"
            }, _hoisted_9, 8, _hoisted_7)
          ])
        ]),
        _hoisted_10,
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("span", null, [
              _hoisted_13,
              _createTextVNode(" Opens " + _toDisplayString(_ctx.formatDate(round.opensAt)), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("span", null, [
              _hoisted_15,
              _createTextVNode(" closes " + _toDisplayString(_ctx.formatDate(round.closesAt)), 1)
            ])
          ])
        ]),
        _createElementVNode("div", {
          class: _normalizeClass(["card", _ctx.widgetClasses])
        }, [
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("div", {
                class: _normalizeClass([['mb-7', `bg-light-info`], "d-flex align-items-center rounded p-5 mb-7"])
              }, [
                _createElementVNode("span", {
                  class: _normalizeClass([`svg-icon-info`, "svg-icon me-5"])
                }, [
                  _createElementVNode("span", _hoisted_18, [
                    _createVNode(_component_inline_svg, { src: "media/icons/duotune/abstract/abs027.svg" })
                  ])
                ]),
                _hoisted_19,
                _createElementVNode("span", {
                  class: _normalizeClass([`text-info`, "fw-bolder py-1"])
                }, _toDisplayString(_ctx.formatter(round.investment_required, "GBP")), 1)
              ])
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("div", {
                class: _normalizeClass([['mb-7', `bg-light-info`], "d-flex align-items-center rounded p-5 mb-7"])
              }, [
                _createElementVNode("span", {
                  class: _normalizeClass([`svg-icon-info`, "svg-icon me-5"])
                }, [
                  _createElementVNode("span", _hoisted_20, [
                    _createVNode(_component_inline_svg, { src: "media/icons/duotune/abstract/abs027.svg" })
                  ])
                ]),
                _hoisted_21,
                _createElementVNode("span", {
                  class: _normalizeClass([`text-info`, "fw-bolder py-1"])
                }, _toDisplayString(_ctx.formatter(round.preMoneyValuation, "GBP")), 1)
              ])
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("div", {
                class: _normalizeClass([['mb-7', `bg-light-info`], "d-flex align-items-center rounded p-5 mb-7"])
              }, [
                _createElementVNode("span", {
                  class: _normalizeClass([`svg-icon-info`, "svg-icon me-5"])
                }, [
                  _createElementVNode("span", _hoisted_22, [
                    _createVNode(_component_inline_svg, { src: "media/icons/duotune/abstract/abs027.svg" })
                  ])
                ]),
                _hoisted_23,
                _createElementVNode("span", {
                  class: _normalizeClass([`text-info`, "fw-bolder py-1"])
                }, _toDisplayString(_ctx.formatter(round.minimumInvestment, "GBP")), 1)
              ])
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("div", {
                class: _normalizeClass([['mb-7', `bg-light-info`], "d-flex align-items-center rounded p-5 mb-7"])
              }, [
                _createElementVNode("span", {
                  class: _normalizeClass([`svg-icon-info`, "svg-icon me-5"])
                }, [
                  _createElementVNode("span", _hoisted_24, [
                    _createVNode(_component_inline_svg, { src: "media/icons/duotune/abstract/abs027.svg" })
                  ])
                ]),
                _hoisted_25,
                _createElementVNode("span", {
                  class: _normalizeClass([`text-info`, "fw-bolder py-1"])
                }, _toDisplayString(_ctx.formatter(round?.totalInvestment, "GBP")), 1)
              ])
            ]),
            _createElementVNode("div", null, [
              _hoisted_26,
              _createElementVNode("div", _hoisted_27, [
                (round?.fundingRoundInvestments?.length ?? false)
                  ? (_openBlock(), _createBlock(_component_InvestmentHistory, {
                      key: 0,
                      investments: round?.fundingRoundInvestments ?? [],
                      currencyCode: 
                  _ctx.currencyCodeSymbolEnums[_ctx.business?.currencyCode ?? 'pound']
                
                    }, null, 8, ["investments", "currencyCode"]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_28, "No Entries"))
              ])
            ])
          ])
        ], 2),
        _createElementVNode("div", _hoisted_29, [
          _createElementVNode("div", _hoisted_30, [
            _createElementVNode("span", {
              style: _normalizeStyle(
              round?.status == 1
                ? 'background-color: green; color: white'
                : round?.status == 2
                ? 'background-color: red; color: white'
                : ''
            ),
              class: "text-royalblue py-1 px-2 rounded-5 font-weight-bold"
            }, _toDisplayString(round?.status == 0
                ? "Awaiting Approval"
                : round?.status == 1
                ? "Approved"
                : "Rejected"), 5)
          ])
        ]),
        _createVNode(_component_DeleteFundingRoundModal, {
          onRoundDeleted: _ctx.roundDeleted,
          businessId: round.businessId,
          id: round.id
        }, null, 8, ["onRoundDeleted", "businessId", "id"])
      ]))
    }), 128))
  ]))
}